import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 10,
        px: 3,
        textAlign: "center",
      }}
    >
      <Typography variant="h1" sx={{ fontSize: "6rem", fontWeight: 700, color: "primary.main", mb: 1 }}>
        404
      </Typography>
      <Typography variant="h5" sx={{ mb: 1, fontWeight: 600, color: "text.primary" }}>
        {isRTL ? "الصفحة غير موجودة" : "Page Not Found"}
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, color: "text.secondary", maxWidth: 450 }}>
        {isRTL
          ? "عذراً، الصفحة التي تبحث عنها غير موجودة أو تم نقلها."
          : "Sorry, the page you are looking for does not exist or has been moved."}
      </Typography>
      <Button
        variant="contained"
        size="large"
        onClick={() => navigate("/")}
        sx={{ borderRadius: 2, px: 5 }}
      >
        {isRTL ? "العودة للصفحة الرئيسية" : "Go to Home"}
      </Button>
    </Box>
  );
};

export default NotFound;
